/**
 * Message utility functions
 * Provides common message parsing and formatting utilities
 */

/**
 * Message type constants from Matrix spec
 */
export const MESSAGE_TYPES = {
  TEXT: 'm.text',
  EMOTE: 'm.emote',
  IMAGE: 'm.image',
  VIDEO: 'm.video',
  AUDIO: 'm.audio',
  FILE: 'm.file',
};

/**
 * Parse /me emote command and return appropriate msgtype and body
 * The /me command is IRC-style action syntax: "/me waves" displays as "* Username waves"
 *
 * @param {string} messageBody - Raw message text
 * @returns {{ body: string, msgtype: string }} Parsed message with body and msgtype
 *
 * @example
 * parseEmoteCommand('/me waves hello')
 * // returns { body: 'waves hello', msgtype: 'm.emote' }
 *
 * @example
 * parseEmoteCommand('/me')
 * // returns { body: '/me', msgtype: 'm.text' } - too short, treated as literal
 *
 * @example
 * parseEmoteCommand('hello world')
 * // returns { body: 'hello world', msgtype: 'm.text' }
 */
export const parseEmoteCommand = (messageBody) => {
  // Check for /me emote command (must have content after '/me ')
  // Length > 4 ensures there's at least one character after '/me '
  if (messageBody.startsWith('/me ') && messageBody.length > 4) {
    return {
      body: messageBody.substring(4), // Remove '/me ' prefix
      msgtype: MESSAGE_TYPES.EMOTE,
    };
  }
  return {
    body: messageBody,
    msgtype: MESSAGE_TYPES.TEXT,
  };
};
